import { useEffect } from "react";

export function useDocumentTitle(title, prevailOnUnmount = false) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    return () => {
      if (!prevailOnUnmount) {
        document.title = prevTitle;
      }
    };
  }, [title, prevailOnUnmount]);
}
